import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=bd8d0c96"
import script from "./FilterSelector.vue?vue&type=script&lang=js"
export * from "./FilterSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports